export default __webpack_public_path__ + "static/media/Ferony-200.0940a7b6.jpg";